import { AxiosResponse } from 'axios';
import { ApiResponseModel } from 'models/api';
import baseService from 'services/base-service';
import { INotificationModel } from 'models/notification/index';
import { IModuleNotification } from 'store/state/auth-state';
import { IBaseSearchRequest, SearchResult } from 'models/base-type';

const endPointBaseURL = `patients/Notification`;

const getNotificationList = async (
    requestBody: IBaseSearchRequest,
    isBackgroundService = false,
): Promise<AxiosResponse<ApiResponseModel<SearchResult<INotificationModel>>>> =>
    baseService.post<ApiResponseModel<SearchResult<INotificationModel>>>(
        `${endPointBaseURL}/GetNotificationList`,
        requestBody,
        isBackgroundService ? { isBackgroundService: true, showLoader: false } : undefined,
    );

const getNotificationUnreadCount = async (
    userId: string,
    forManagedCare: boolean,
): Promise<AxiosResponse<ApiResponseModel<number>>> =>
    baseService.get<ApiResponseModel<number>>(
        `${endPointBaseURL}/GetNotificationUnreadCount?userId=${userId}&forManagedCare=${forManagedCare}`,
        { isBackgroundService: true, showLoader: false },
    );

const updateNotification = async (requestBody: INotificationModel): Promise<AxiosResponse<ApiResponseModel<number>>> =>
    baseService.post<ApiResponseModel<number>>(`${endPointBaseURL}/UpdateNotification`, requestBody);

const getPatientMenuNotificationCount = async (
    patientId?: string,
    userId?: string,
    moduleName?: string,
): Promise<AxiosResponse<ApiResponseModel<Array<IModuleNotification>>>> =>
    baseService.get<ApiResponseModel<Array<IModuleNotification>>>(
        `${endPointBaseURL}/GetPatientModuleNotificationCounts?patientId=${patientId}&userId=${userId}&moduleName=${moduleName}`,
    );

const readNotifications = async (
    notificationIds: string,
    userId: string,
): Promise<AxiosResponse<ApiResponseModel<number>>> =>
    baseService.get<ApiResponseModel<number>>(
        `${endPointBaseURL}/MarkAllAsReadNotification?notificationIds=${notificationIds}&&userId=${userId}`,
    );

const deleteNotification = async (
    notificationIds: string,
    userId: string,
): Promise<AxiosResponse<ApiResponseModel<number>>> =>
    baseService.post<ApiResponseModel<number>>(
        `${endPointBaseURL}/DeleteNotification?notificationIds=${notificationIds}&&userId=${userId}`,
    );

export default {
    getNotificationList,
    getNotificationUnreadCount,
    updateNotification,
    getPatientMenuNotificationCount,
    readNotifications,
    deleteNotification,
};
